import { UsersAdmin } from "@/features/admin/UsersAdmin";
import { useAppShell } from "@/shell/app-shell-context";
import { isMaster } from "@/shared/utils/roles";

export function UsersAdminRoute() {
  const { token, profile } = useAppShell();
  return (
    <UsersAdmin
      token={token}
      master={isMaster(profile)}
      loginMode={profile.login_mode ?? null}
    />
  );
}
